/**
 * Public language and unit rollout, approved after device testing on 2026-10-07.
 *
 * While `false`, the „Automatikus" language means Hungarian and the
 * „Automatikus" unit system means metric, for EVERY device: shipping a
 * half-translated English UI to non-Hungarian phones (and to the App Store
 * reviewer) would be worse than staying Hungarian. The current owner/admin
 * can still pick English or imperial explicitly when previewing a closed rollout.
 *
 * Flip it in the last i18n phase — docs/ai/terv-2026-10-06-i18n.md → 3.
 */
export const AUTO_LOCALE_ENABLED = true;

/**
 * The production early-access gate intentionally follows the write-capable
 * admin roles, not the tester flag or every role that can read the admin
 * area. This is a rollout/UI gate, not an authorization boundary: the
 * dictionary is shipped in the web bundle and sensitive operations stay
 * protected by the server.
 */
export function canPreviewLocale(role: string | null | undefined): boolean {
  return role === 'owner' || role === 'admin';
}

/** Vite injects `env` in the browser; the shared backend build does not. */
function isDevelopmentBuild(): boolean {
  return (import.meta as ImportMeta & { env?: { DEV?: boolean } }).env?.DEV === true;
}

/** Local development remains available without a Firebase-configured account. */
export function isLocalePreviewAvailable(role: string | null | undefined): boolean {
  return AUTO_LOCALE_ENABLED || isDevelopmentBuild() || canPreviewLocale(role);
}
